import React, { useState, useRef, useEffect } from 'react';
import AppHeader from '../AppHeader';
import MainInput from '../MainInput';
import PostItem from '../PostItem';
import styles from './index.module.scss';
import ResizeObserver from 'resize-observer-polyfill';
import useWindowSize from '../../hooks/useWindowSize';

import PostService from '../../services/post';

let postService: PostService;

const MainContent = () => {
    const [posts, setPosts] = useState<Object[]>([]);

    useEffect(() => {
        postService = new PostService();
        setPosts(postService.getPosts());
    }, []);

    const headerRef = useRef<Element>();
    const inputRef = useRef<Element>();
    const [postsHeight, setPostsHeight] = useState(0);
    const windowSize = useWindowSize();
    const observer = useRef(new ResizeObserver((entries: any) => {
        let headerHeight = 0;
        if (headerRef && headerRef.current) {
            headerHeight = (headerRef.current as HTMLElement).offsetHeight;
        }
        for (const entry of entries) {
            const { height, y } = entry.contentRect;
            // Assume top & bottom gaps have same magnitude
            const inputHeight = height + y * 2;
            setPostsHeight(window.innerHeight - inputHeight - headerHeight);
        }
    }));

    useEffect(() => {
        if (inputRef && inputRef.current) {
            observer.current.observe(inputRef.current as Element);
        }

        return () => {
            if (inputRef && inputRef.current) {
                observer.current.unobserve(inputRef.current as Element);
            }
        }
    }, [headerRef, observer, inputRef, windowSize]);

    return (
        <div className={styles.container}>
            <AppHeader title="Roger J."
                       subtitle="Manager"
                       avatarText="R"
                       menuItems={[
                        {label: "Export Postings"}
                       ]}
                       theme="light"
                       ref={headerRef}></AppHeader>
            <div className={styles.posts} style={{height: postsHeight}}>
                {posts.map((p, i) => <PostItem post={p} key={i} />)}
            </div>
            <MainInput ref={inputRef}></MainInput>
        </div>
    );
};

export default MainContent;